export const NEEDS_MFA_SETUP = 'MISSING_MFA_TOKEN';
export const NEEDS_MFA_CODE = 'MFA_DEVICE_ALREADY_REGISTERED';
